import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Modal from 'components/Modal';

import QuoteView from 'components/layout/QuoteView';

import Data from 'components/Data';

class QuoteDetails extends React.Component {
  close = e => {
    e.preventDefault();
    const { close } = this.props;
    close();
  };

  render() {
    const {
      alreadyInModal,
      intl: { messages },
      show,
      quoteId,
      quote: propsQuote,
      quoteData,
      close,
    } = this.props;

    const quote = propsQuote || (quoteId && !quoteData.pending && quoteData.data);
    const data = show && !!quoteId && (
      <Data dataName="invoice" url={`/api/invoices/${quoteId}.json`} data={quoteData} />
    );
    const content = !!quote && <QuoteView data={quote} />;

    return alreadyInModal ? (
      <div className={show ? '' : 'hide'}>
        <div className="bg-master-lightest padding-10 p-l-20 cursor" onClick={this.close}>
          <i className="m-r-10 fa fa-angle-left" /> {messages.back}
        </div>

        {data}
        {content}
      </div>
    ) : (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.salesDoc.quote}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{content}</Modal.Body>
      </Modal>
    );
  }
}
QuoteDetails.defaultProps = {
  alreadyInModal: false,
};

const mapStateToProps = state => {
  return {
    quoteData: state.data.quote,
  };
};

export default injectIntl(connect(mapStateToProps)(QuoteDetails));
